(() => {
  if (customElements.get('ff-birthday')) return;
  let queue = Promise.resolve();
  const lengths = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  function normalize(day, month) {
    if (!day && !month) return '';
    if (!/^\d{2}$/.test(day) || !/^\d{2}$/.test(month)) return null;
    const d = Number(day), m = Number(month);
    return m >= 1 && m <= 12 && d >= 1 && d <= lengths[m - 1] ? day + '.' + month : null;
  }
  class Birthday extends HTMLElement {
    connectedCallback() {
      this.day = this.querySelector('[data-birthday-day]');
      this.month = this.querySelector('[data-birthday-month]');
      this.button = this.querySelector('[data-birthday-save]');
      this.status = this.querySelector('[data-birthday-status]');
      this.saved = this.dataset.saved || '';
      this.onChange = () => this.update();
      this.onSave = () => this.save();
      this.onSync = event => {
        this.saved = event.detail;
        const parts = this.saved.split('.');
        this.day.value = parts[0] || '';
        this.month.value = parts[1] || '';
        this.update(true);
      };
      this.addEventListener('change', this.onChange);
      this.button.addEventListener('click', this.onSave);
      window.addEventListener('ff:birthday-saved', this.onSync);
      this.update(true);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.button.removeEventListener('click', this.onSave);
      window.removeEventListener('ff:birthday-saved', this.onSync);
    }
    text(key) {
      const en = this.dataset.language === 'en';
      return ({invalid: en ? 'Please select a valid day and month, or leave both empty.' : 'Bitte wähle einen gültigen Tag und Monat oder lasse beide Felder leer.', dirty: en ? 'Not saved yet. Use Save to add this optional detail.' : 'Noch nicht gespeichert. Über SPEICHERN übernimmst du die freiwillige Angabe.', saved: en ? 'Saved for this order.' : 'Für diese Bestellung gespeichert.', removed: en ? 'Removed from this order.' : 'Aus dieser Bestellung entfernt.', saving: en ? 'Saving…' : 'Wird gespeichert…', error: en ? 'Could not confirm saving. Please try again. You can still order without this detail.' : 'Speichern konnte nicht bestätigt werden. Bitte versuche es erneut. Du kannst weiterhin ohne diese Angabe bestellen.'})[key];
    }
    update(synced = false) {
      const value = normalize(this.day.value, this.month.value);
      this.button.disabled = this.busy || value === null || value === this.saved;
      this.status.textContent = value === null ? this.text('invalid') : value !== this.saved ? this.text('dirty') : this.saved ? this.text('saved') : synced ? '' : this.text('removed');
    }
    async save() {
      const value = normalize(this.day.value, this.month.value);
      if (this.busy || value === null || value === this.saved) return;
      this.busy = true;
      this.button.disabled = true;
      this.day.disabled = this.month.disabled = true;
      this.status.textContent = this.text('saving');
      const operation = async () => {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 12000);
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(root + 'cart/update.js', {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({attributes: {ff_birthday_day_month: value}}), signal: controller.signal});
          if (!response.ok) throw new Error('save');
          const cart = await response.json();
          if ((cart.attributes?.ff_birthday_day_month || '') !== value) throw new Error('verify');
          window.dispatchEvent(new CustomEvent('ff:birthday-saved', {detail: value}));
          return value;
        } finally { window.clearTimeout(timeout); }
      };
      const task = queue.then(operation);
      queue = task.catch(() => {});
      try {
        this.saved = await task;
        this.busy = false;
        this.day.disabled = this.month.disabled = false;
        this.update();
      } catch (_) {
        this.busy = false;
        this.day.disabled = this.month.disabled = false;
        this.update();
        this.status.textContent = this.text('error');
      }
    }
  }
  customElements.define('ff-birthday', Birthday);
})();
